import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip, Typography } from '@mui/material';
import toast from 'react-hot-toast';

import Container from './styles/Container';
import Wrapper from './styles/Wrapper';
import validateFile from '../../utils/validateFile';
import FileName from '../FileName/FileName';

const defaultError = 'Ошибка при обработке файла, попробуйте еще раз';
const sizeError = 'Максимально допустимый размер файла 5 MB';

function FileUploader({ id, file, setFile, label, accept }) {
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      // Проверка на расширение (если задан accept)
      if (accept) {
        const allowedExtensions = accept.split(',').map((ext) => ext.trim().toLowerCase());
        const fileName = selectedFile.name.toLowerCase();
        const isValidExtension = allowedExtensions.some((ext) => fileName.endsWith(ext));

        if (!isValidExtension) {
          toast.error(`Допустимые форматы: ${accept}`);
          return null;
        }
      }

      if (!validateFile(selectedFile)) {
        toast.error(sizeError);
        return null;
      }

      setFile(selectedFile);
      return selectedFile;
    }

    toast.error(defaultError);
    return null;
  };

  const handleFileClick = () => {
    if (fileInputRef.current?.click) fileInputRef.current.click();
    else toast.error(defaultError);
  };

  return (
    <Container>
      <Typography variant="body1" component="div" sx={{ display: 'flex' }}>
        {label}
      </Typography>
      <Wrapper>
        <input
          ref={fileInputRef}
          accept={accept}
          style={{ display: 'none' }}
          id={id}
          multiple
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor={id}>
          <Tooltip title="" placement="right" arrow>
            <Button
              onClick={handleFileClick}
              variant={file ? 'contained' : 'outlined'}
              component="button"
              sx={{ minWidth: '210px' }}
            >
              {file ? 'Изменить файл' : 'Выбрать файл'}
            </Button>
          </Tooltip>
        </label>
        {file?.name && <FileName nameFile={file.name} />}
      </Wrapper>
    </Container>
  );
}

FileUploader.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  file: PropTypes.shape().isRequired,
  setFile: PropTypes.func.isRequired,
  accept: PropTypes.string,
};

FileUploader.defaultProps = {
  accept: '',
};

export default FileUploader;
